import { render, staticRenderFns } from "./ShareVoteCourse.vue?vue&type=template&id=3732fb74"
import script from "./ShareVoteCourse.vue?vue&type=script&lang=js"
export * from "./ShareVoteCourse.vue?vue&type=script&lang=js"
import style0 from "./ShareVoteCourse.vue?vue&type=style&index=0&id=3732fb74&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports